import { MenuOptionsGroup, Menu } from "core/dashboard/menu/menu";
import type { FeaturePermissionKey } from "@/app/shared/permissions/featurePermissions";
import { canAny, hasAnyRoleLabel } from "@/app/shared/permissions/permissionKernel";

class MenuByRoleBuilderService {
  constructor(private readonly menu: Menu) {}

  private itemAllowed(menuOption: {
    featurePermissions?: readonly FeaturePermissionKey[];
    roleLabels?: readonly string[];
  }): boolean {
    if (menuOption.roleLabels?.length && !hasAnyRoleLabel(menuOption.roleLabels)) {
      return false;
    }
    if (!menuOption.featurePermissions?.length) return true;
    return canAny(menuOption.featurePermissions);
  }

  private buildMenuOptionsGroup(
    menuOptionsGroup: MenuOptionsGroup
  ): MenuOptionsGroup {
    menuOptionsGroup.children = menuOptionsGroup.children
      .filter((menuOption) => this.itemAllowed(menuOption))
      .map((menuOption) => {
        if ((menuOption as MenuOptionsGroup).children) {
          return this.buildMenuOptionsGroup(menuOption as MenuOptionsGroup);
        }

        return menuOption;
      });

    return menuOptionsGroup;
  }

  buildMenu(): Menu {
    return this.menu
      .filter((menuOption) =>
        this.itemAllowed(
          menuOption as {
            featurePermissions?: readonly FeaturePermissionKey[];
          },
        ),
      )
      .map((menuOption) => {
        if ((menuOption as MenuOptionsGroup).children) {
          return this.buildMenuOptionsGroup(menuOption as MenuOptionsGroup);
        }
        return menuOption;
      })
      .filter((menuOption) => {
        if ((menuOption as MenuOptionsGroup).children) {
          return (menuOption as MenuOptionsGroup).children.length > 0;
        }
        return true;
      });
  }
}

export default MenuByRoleBuilderService;
